export { DetailsFiles } from './DetailsFiles';
